module.exports = __webpack_public_path__ + "static/media/icons.efeef1b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons.svg
// module id = 299
// module chunks = 17